import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { EnumAppointmentStatus, EnumPatientStatus } from "../../../libs";

export interface ITableVariantState {
  status?: EnumAppointmentStatus | EnumPatientStatus;
  startDate?: string | null;
  endDate?: string | null;
  tasks?: string[];
  patientSKey?: string | null;
  caregiverSKey?: string | null;
}

export interface ITableState extends ITableVariantState {
  pageNumber: number;
  pageSize: number;
  searchKey: string;
  isLoading: boolean;
  nextPageToken: null | string;
  skeys: string[];
  shouldRefetch: boolean;
}

const initialState: ITableState = {
  pageNumber: 1,
  pageSize: 10,
  searchKey: "",
  isLoading: false,
  nextPageToken: null,
  skeys: [],
  shouldRefetch: false,
  patientSKey: null,
  caregiverSKey: null,
};

export const generateTableSlice = (tableName: string) => {
  const slice = createSlice({
    name: tableName + "Table",
    initialState,
    reducers: {
      nextPage: (state) => {
        state.pageNumber += 1;
      },

      previousPage: (state) => {
        state.pageNumber = Math.min(state.pageNumber - 1, 1);
      },

      goToPage: (state, action: PayloadAction<number>) => {
        state.pageNumber = action.payload;
      },

      setEntryCount: (state, action: PayloadAction<number>) => {
        state.pageSize = action.payload;
      },

      setSearchKey: (state, action: PayloadAction<string>) => {
        state.searchKey = action.payload;
      },

      setIsLoading: (state, action: PayloadAction<boolean>) => {
        state.isLoading = action.payload;
      },

      setNextPageToken: (state, action: PayloadAction<null | string>) => {
        state.nextPageToken = action.payload;
      },

      setRowSkeys(state, action: PayloadAction<string[]>) {
        state.skeys = action.payload;
      },

      setRefetch(state, action: PayloadAction<boolean>) {
        state.shouldRefetch = action.payload;
      },

      setStartDate(state, action: PayloadAction<string | null>) {
        state.startDate = action.payload;
      },

      setEndDate(state, action: PayloadAction<string | null>) {
        state.endDate = action.payload;
      },

      setStatus(
        state,
        action: PayloadAction<EnumAppointmentStatus | EnumPatientStatus>
      ) {
        state.status = action.payload;
      },

      setTasks(state, action: PayloadAction<string[]>) {
        state.tasks = action.payload;
      },

      setPatientSKey(state, action: PayloadAction<string | null>) {
        state.patientSKey = action.payload;
      },

      setCaregiverSKey(state, action: PayloadAction<string | null>) {
        state.caregiverSKey = action.payload;
      },

      resetData() {
        return initialState;
      },
    },
  });

  return slice;
};
